module.exports = __webpack_public_path__ + "static/media/gopuram.f8ad4170.svg";